import DataBox from './DataBox';

export default DataBox;
